<main>
    <pagination-loading-overlay [isLoading]="isLoading" [currentPage]="currentPage">
        <section class="overflow-box" aria-labelledby="my-compliance-heading">
            <h1 id="my-compliance-heading" class="visually-hidden">My Compliance Items</h1>
            <user-summary [user]="user"
                        [itemPackets]="itemPackets"
                        [summaryItems]="pagedResponse?.Results"
                        [isUser]="isUser"
                        [isMyItems]="isMyItems"
                    [archived]="archived"></user-summary>
        </section>
    </pagination-loading-overlay>

    <div class="content">
        <div class="row">
            <div class="col-sm-12 text-end">
                <edl-pagination *ngIf="pagedResponse?.TotalNumberPages > 1"
                                [collectionSize]="pagedResponse?.TotalCount"
                                [(page)]="currentPage"
                                [pageSize]="pagedResponse?.Limit"
                                (pageChange)="onPageChange($event)"></edl-pagination>
            </div>
        </div>
    </div>
</main>